import styled from "styled-components";

export const StyledPartialTsDetalhado = styled.section`
.flex-column-7 {
    width: 82% !important;
}
.flex-column-3 {
    width: 40% !important;
}

@media (max-width: 768px){
    .flex-column-7 {
        width: 100% !important;
    }
    .flex-column-3 {
        width: 100% !important;
    }
}
.legend-info {
    font-size: 15px !important;
}
.input-form-num-ts {
    padding: 0.7rem 0.5rem;
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: 60px;
    height: 38px;
}

.default-button-red{
    min-width: 135px;
}

@media (max-width: 365px) OR (min-width: 1800px){
    .default-button-red{
        min-width: 120px;
    }
}

.menu-link {
    padding: 0 3px;
    color: #cac6c6;
    &:hover {
        color: #ef4623;
    }
}

.btn-voltar, .btn-voltar:hover {
    color: #ef4623;
    font-size: 20px;
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}

.hover {
    &:hover {
        cursor: pointer;
    }
}

.timeline-menu-show {
    position: absolute;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.05);
    top 23px;
    border: 1px solid #bebebe;
    border-radius: 11px;
    z-index: 1;
}
`;
